// extracted by mini-css-extract-plugin
export var adjustableWidthBorder = "_16-7";
export var adjustableWidthBorderHeld = "_16-8";
export var arrow = "_16-3";
export var arrowButton = "_16-4";
export var headerCell = "_16-0";
export var help = "_16-2";
export var icon = "_16-1";
export var iconWrapper = "_16-6";
export var noBorder = "_16-b";
export var nonAdjustableWidthBorder = "_16-9";
export var nonAdjustableWidthBorderHeld = "_16-a";
export var textButton = "_16-5";